import { useCallback, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import useTranslation from 'next-translate/useTranslation'
import { apiGet } from 'tennders-stracture/libs/api'
import { dispatchStatusUpdate } from 'tennders-common/stores/prompt/action'

const useStatusUpdate = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const statusupdate = useSelector((state) => state.prompt.statusupdate)
  const [title, settitle] = useState('')
  const [message, setmessage] = useState('')

  const setstatusupdate = (status) => dispatch(dispatchStatusUpdate(status))

  const loadStatusMessage = async (status) => {
    const response = await apiGet(`utils/status/${status}`)
    setmessage(response.message)
    settitle(t(`variables:${response.actionStr}`))
  }

  const resetTexts = useCallback(() => {
    settitle('')
    setmessage('')
  }, [])

  return {
    statusMessage: message,
    statusTitle: title,
    loadStatusMessage,
    statusupdate,
    setstatusupdate,
    resetTexts
  }
}

export default useStatusUpdate
